<template>
    <span class="validation-message-wrapper">
        <span class="validation-message has-error" v-show="field.$error">
            <!--<pre>{{ field }}</pre>-->
            <span v-for="entry in invalidParams"
                  :key="entry.key"
            >
                {{ $t("VALIDATION_" + entry.params.type, {
                    field : $t("VALIDATION_FIELDNAME_" + fieldName),
                    min : entry.params.min, length: entry.params.length
                }) }}
            </span>
        </span>
    </span>
</template>
<!---------------------------------------------------------------------------->
<script>
    export default {
        props : {
            field : { type : Object, default : null },
            fieldName : { type : String, default : "" }
        },

        computed : {
            invalidParams() {
                return Object.entries(this.field.$params || {})
                    .filter(([key]) => !this.field[key])
                    .map(([key, params]) => ({ key, params }));
            }
        }
    };
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
</style>